// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b2de4079","823":"75fd716b"}[chunkId] + ".chunk.js";
};